export default __webpack_public_path__ + "static/media/5.6d8996b0.png";